module.exports = __webpack_public_path__ + "static/img/Korea.b6751ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Korea.png
// module id = pikd
// module chunks = 1